<template>
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="50%"
        :before-close="closeDialog">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="应用名称" prop="title">
              <el-input v-model="ruleForm.title" style="width: 46%;" placeholder="请输入应用名称"></el-input>
            </el-form-item>
            <el-form-item label="应用类型" prop="type">
              <el-select v-model="ruleForm.type" placeholder="请选择应用类型">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="应用描述" prop="describe">
              <el-input type="textarea" v-model="ruleForm.describe" style="width: 46%;" :rows="8" placeholder="请输入应用描述"></el-input>
            </el-form-item>
            <el-form-item label="应用主页" prop="mainUrl">
              <el-input v-model="ruleForm.mainUrl" style="width: 46%;" placeholder="请输入应用主页"></el-input>
            </el-form-item>
            <el-form-item label="应用回调地址" prop="loginUrl">
              <el-input v-model="ruleForm.loginUrl" style="width: 46%;" placeholder="请输入应用回调地址"></el-input>
            </el-form-item>
            <el-form-item label="注册接口url" prop="registerUrl">
              <el-input v-model="ruleForm.registerUrl" style="width: 46%;" placeholder="请输入注册接口url"></el-input> <span @click="changeFlag"><img class="arrowIcon" :class="{'open': flag}" src="../../../assets/images/zhankai.png" /></span>
            </el-form-item>
            <template v-if="flag">
            <el-form-item label="请求方式">
              POST
            </el-form-item>
            <el-form-item label="请求参数">
               <el-table
                :data="tableData"
                :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }"
                border
                style="width: 100%">
                <el-table-column
                  prop="paramName"
                  label="参数名称"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="paramType"
                  label="参数类型"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="explain"
                  label="说明">
                </el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item label="响应参数">
               <el-table
                :data="tableData2"
                :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }"
                border
                style="width: 100%">
                <el-table-column
                  prop="paramName"
                  label="参数名称"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="paramType"
                  label="参数类型"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="explain"
                  label="说明">
                </el-table-column>
              </el-table>
            </el-form-item>
            </template>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { fetchAddApp, fetchEditApp, fetchAllCategory } from '@/api/api'
export default {
  data() {
    return {
      mode: 'add',
      title: '添加应用',
      dialogVisible: false,
      ruleForm: {
        title: '',
        describe: '',
        mainUrl: '',
        loginUrl: '',
        type: '',
      },
      editId: '',
      options: [],
      rules: {
          title: [
            { required: true, message: '请输入应用名称', trigger: 'blur' },
          ],
          describe: [
            { required: true, message: '请输入应用描述', trigger: 'blur' },
          ],
          mainUrl: [
            { required: true, message: '请输入应用主页', trigger: 'blur' },
          ],
          type:[
            { required: true, message: '请输入应用主页', trigger: ['blur','change'] },
          ],
          loginUrl: [
            { required: true, message: '请输入应用回调地址', trigger: 'blur' },
          ],
          registerUrl: [
            { required: true, message: '注册接口url', trigger: 'blur' },
          ]
      },
      tableData:[
        {
          paramName: 'username',
          paramType: 'String',
          explain:'用户名'
        },
        {
          paramName: 'password',
          paramType: 'String',
          explain:'密码'
        },
        {
          paramName: 'clientId',
          paramType: 'String',
          explain:'客户端id'
        },
        {
          paramName: 'clientSecret',
          paramType: 'String',
          explain:'密钥'
        },
      ],
      tableData2:[
        {
          paramName: 'code',
          paramType: 'Int',
          explain:'响应状态(1:成功 0:失败)'
        },
        {
          paramName: 'msg',
          paramType: 'String',
          explain:'响应信息'
        },
      ],
      flag: false,
    }
  },
  created() {
    this.getOptions()
  },
  methods: {
    getOptions() {
      fetchAllCategory().then(res => {
        this.options = res.data
      })
    },
    openDialog(data) {
        if(data) {
            this.mode = 'edit'
            this.title = '编辑应用'
            this.initData(data)
        }else {
            this.mode = 'add'
            this.title = '添加应用'
        }
        this.dialogVisible = true
    },
    closeDialog() {
        this.dialogVisible = false
        this.$refs.ruleForm.resetFields();
        this.$emit('closeAppDialog')
    },
    initData(data) {
        const { title, describe, mainUrl, loginUrl, type,id} = data
        this.ruleForm.title = title
        this.ruleForm.describe = describe
        this.ruleForm.mainUrl = mainUrl
        this.ruleForm.loginUrl = loginUrl
        this.ruleForm.type = type
        this.editId=id
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if(valid) {
            if(this.mode === 'add') {
              fetchAddApp(this.ruleForm).then(res => {
                    if(res.code == 1) {
                        this.$message.success('添加成功');
                        this.closeDialog()
                    }else {
                        this.$message.error('添加失败');
                    }
              })
            }else {
                let params={
                  id: this.editId,
                  ...this.ruleForm
                }
                fetchEditApp(params).then(res => {
                    if(res.code == 1) {
                        this.$message.success('编辑成功');
                        this.closeDialog()
                    }else {
                        this.$message.error('编辑失败');
                    }
                })
            }
          
        }
      })
    },
    changeFlag() {
      this.flag = !this.flag
    }
  },

}
</script>
<style scoped>
.arrowIcon{
  width: 30px;
  vertical-align: middle;
  margin-left: 10px;
  cursor: pointer;
}
.arrowIcon.open{
  transform: rotate(180deg);
}
/deep/ .el-dialog__body{
  height: 530px;
  overflow-y: auto;
}
/deep/ .el-dialog__body::-webkit-scrollbar { width: 0 !important }
</style>



// WEBPACK FOOTER //
// src/views/console/components/AppDialog.vue